import { useAppSelector } from "@/lib/redux/hooks"

export const useIsAuthen = () => useAppSelector(state => state.user.isAuthen)